document.documentElement.classList.add('go-js');
document.addEventListener('click',function(e){const a=e.target.closest('[data-go-scroll]');if(!a)return;const target=a.getAttribute('href');if(!target||target.charAt(0)!=='#')return;const el=document.querySelector(target);if(el){e.preventDefault();el.scrollIntoView({behavior:'smooth',block:'start'});}});

if(document.querySelector('[data-go-business-page]')){
  if('scrollRestoration' in history)history.scrollRestoration='manual';
  window.addEventListener('pageshow',function(){
    if(!window.location.hash)window.scrollTo({top:0,left:0,behavior:'auto'});
  },{once:true});
}

const proposalForm=document.getElementById('GameOnBusinessProposalForm');
if(proposalForm){
  proposalForm.addEventListener('submit',function(){
    const button=proposalForm.querySelector('[data-go-form-submit]');
    if(!button)return;
    const label=button.querySelector('span');
    const originalLabel=label?label.textContent:'';
    const progress=proposalForm.querySelector('[data-go-form-progress]');
    button.disabled=true;
    button.setAttribute('aria-disabled','true');
    if(label)label.textContent=button.dataset.loadingText||'Sending…';
    if(progress){
      progress.hidden=false;
      progress.textContent=progress.dataset.sendingText||'Sending your project brief securely…';
    }

    const restoreAfterChallenge=function(){
      if(!document.body.contains(proposalForm))return;
      button.disabled=false;
      button.removeAttribute('aria-disabled');
      if(label)label.textContent=originalLabel;
      if(progress){
        progress.hidden=false;
        progress.textContent=progress.dataset.challengeText||'Complete the security check shown on screen to finish sending your brief.';
      }
    };

    const challengeObserver=new MutationObserver(function(){
      if(document.querySelector('iframe[src*="hcaptcha"]')){
        challengeObserver.disconnect();
        restoreAfterChallenge();
      }
    });
    challengeObserver.observe(document.body,{childList:true,subtree:true});
    window.setTimeout(function(){
      challengeObserver.disconnect();
      restoreAfterChallenge();
    },8000);
  });

  const result=proposalForm.querySelector('[data-go-form-success],[data-go-form-error]');
  if(result){
    requestAnimationFrame(function(){
      result.scrollIntoView({behavior:'auto',block:'center'});
      result.focus({preventScroll:true});
    });
  }
}
